"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QRCode = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const qrcode_react_1 = __importDefault(require("qrcode.react"));
const Wrapper = styled_components_1.default.div `
  ${({ theme, size, }) => (0, styled_components_1.css) `
    padding: ${theme.spacing.unit * 2}px;
    box-sizing: border-box;
    width: ${size + theme.spacing.unit * 2}px;
    height: ${size + theme.spacing.unit * 2}px;
  `}
`;
/**
 * QRCode component
 *
 * Extended and customized from `qrcode.react`
 * https://github.com/zpao/qrcode.react
 *
 */
const QRCode = (_a) => {
    var { value, size = 180, imageSettings } = _a, rest = __rest(_a, ["value", "size", "imageSettings"]);
    return (react_1.default.createElement(Wrapper, { size: size },
        react_1.default.createElement(qrcode_react_1.default, Object.assign({ value: value, size: size, imageSettings: imageSettings
                ? Object.assign(Object.assign({}, imageSettings), { excavate: true, height: size * 0.2, width: size * 0.2 }) : {} }, rest))));
};
exports.QRCode = QRCode;
exports.default = exports.QRCode;
//# sourceMappingURL=QRCode.js.map